export default "__VITE_ASSET__8RJ1R9BZ__"